import React from "react";
import { Badge } from "reactstrap";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { GetSelectTime } from "../../../helpers/SelectTime";
import { AddCommaNumber, AddCommaPhoneNumber } from "../../../helpers/Utils";
import moment from "moment";

import { injectIntl } from "react-intl";

const ContentMultiForm = (props) => {
  const { data, onChange, data_tags, intl } = props;
  // console.log(data);
  const columns = [
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.item" }),
      accessor: "stock",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    // {
    //     Header: 'Đơn vị tính',
    //     accessor: 'unit',
    //     Cell: (props) => (
    //         <span className='text-capitalize'>{props.value}</span>
    //     ),
    // },
    // {
    //     Header: 'Mã số',
    //     accessor: 'code',
    //     Cell: (props) => (
    //         <span className='text-uppercase'>{props.value}</span>
    //     ),
    // },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.quantity" }),
      accessor: "quantity",
      Cell: (props) => AddCommaNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.price" }),
      accessor: "price",
      Cell: (props) => AddCommaNumber(props.value),
    },
    {
      Header: intl.formatMessage({
        id: "warehouse.transfer.header.description",
      }),
      accessor: "discription",
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.status" }),
      accessor: "status",
      Cell: (props) => (
        <Badge
          pill
          color={
            props.value === "Đã xét duyệt"
              ? "primary"
              : props.value === "Đang xét duyệt"
                ? "secondary"
                : "danger"
          }
        >
          {props.value}
        </Badge>
      ),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.sender" }),
      accessor: "name",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.phone" }),
      accessor: "phone",
      Cell: (props) => AddCommaPhoneNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.carrier" }),
      accessor: "name_carrier",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({
        id: "warehouse.transfer.header.carrier_phone",
      }),
      accessor: "phone_carrier",
      Cell: (props) => AddCommaPhoneNumber(props.value),
    },
    {
      Header: intl.formatMessage({
        id: "warehouse.transfer.header.destination",
      }),
      accessor: "receiving_warehouse",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.transport" }),
      accessor: "transportation",
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({
        id: "warehouse.transfer.header.shipping_cost",
      }),
      accessor: "cost_transfer",
      Cell: (props) => AddCommaNumber(props.value),
    },
    // {
    //     Header: 'Thống kê',
    //     accessor: 'time',
    //     Cell: (props) => GetSelectTime(props.value).label,
    // },
    {
      Header: intl.formatMessage({ id: "warehouse.transfer.header.creator" }),
      accessor: "user_created_id",
    },
    {
      Header: intl.formatMessage({
        id: "warehouse.transfer.header.created_at",
      }),
      accessor: "createdAt",
      Cell: (props) => moment(props.value).format("DD/MM/YYYY"),
    },
  ];
  return (
    <ReactTable
      defaultPageSize={20}
      data={data}
      columns={columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};

export default injectIntl(ContentMultiForm);
